import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: () => ({
      position: 'absolute',
    }),
  }),
  { name: 'DocumentScoreContainer' }
);
